export const ARQUIVAMENTO_COMMON_ATUALIZA_TAB = 'ARQUIVAMENTO_COMMON_ATUALIZA_TAB';
export const atualizarTab = (tab) => ({
  type: ARQUIVAMENTO_COMMON_ATUALIZA_TAB,
  payload: {
    tab,
  },
});


export const ARQUIVAMENTO_COMMON_ATUALIZAR_DATAINI = 'ARQUIVAMENTO_COMMON_ATUALIZAR_DATAINI';
export const dataInicio = (dataInicio) => ({
  type: ARQUIVAMENTO_COMMON_ATUALIZAR_DATAINI,
  payload: {
    dataInicio,
  },
});
export const ARQUIVAMENTO_COMMON_ATUALIZAR_DATAFIM = 'ARQUIVAMENTO_COMMON_ATUALIZAR_DATAFIM';
export const dataFim = (dataFim) => ({
  type: ARQUIVAMENTO_COMMON_ATUALIZAR_DATAFIM,
  payload: {
    dataFim,
  },
});

export const ARQUIVAMENTO_COMMON_ATUALIZAR_FILTRO_VALUE = 'ARQUIVAMENTO_COMMON_ATUALIZAR_FILTRO_VALUE';
export const filtroValue = (filtroValue) => ({
  type: ARQUIVAMENTO_COMMON_ATUALIZAR_FILTRO_VALUE,
  payload: {
    filtroValue,
  },
});

export const ARQUIVAMENTO_COMMON_ATUALIZA_IMPRIMIR = 'ARQUIVAMENTO_COMMON_ATUALIZA_IMPRIMIR';
export const imprimir = (imprimir) => ({
  type: ARQUIVAMENTO_COMMON_ATUALIZA_IMPRIMIR,
  payload: {
    imprimir,
  },
});


// WEBPACK FOOTER //
// ./src/pages/arquivamento/common/store/arquivamento.action.js